<template>
    <div class="modal is-active">
        <div class="modal-background" />
        <div class="modal-card">
            <header class="modal-card-head is-block bordered py-2 px-2">
                <button
                    class="close is-pulled-left"
                    aria-label="close"
                    @click="$emit('close')"
                >
                    <span class="icon is-large">
                        <i class="mdi mdi-24px mdi-close has-text-black"></i>
                    </span>
                </button>
                <slot name="header" />
            </header>
            <section class="modal-card-body is-paddingless">
                <div class="section is-paddingless">
                    <div class="lb-modal-layout is-marginless">
                        <div
                            v-if="$mq != 'mobile'"
                            class="lb-menu has-background-white-ter"
                        >
                            <slot name="side-menu" />
                        </div>
                        <div class="lb-content">
                            <slot name="main-content" />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        fullwidthHeader: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {};
    },
    computed: {},
    methods: {},
};
</script>

<style scoped>
.modal.is-active.is-transparent .modal-card-head,
.modal.is-active.is-transparent .modal-card-body,
.modal.is-active.is-transparent .modal-card-foot {
    background: transparent;
}
.modal.is-active.is-transparent .modal-card-body::-webkit-scrollbar {
    display: none;
}
.modal.is-active.is-transparent .modal-card-body {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.modal.is-active.is-headless .modal-card-head {
    display: none !important;
}
.modal.is-active.is-footless .modal-card-foot {
    display: none !important;
}
.modal.is-active.is-full-height .modal-card {
    max-height: 100% !important;
}
.modal-card-head.is-block.bordered {
    border-bottom: 1px solid #dbdbdb;
}
</style>
